import { SVGProps } from 'react';

const Crown: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="13"
    viewBox="0 0 15 13"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.6217 0.244364C7.57431 0.168919 7.51122 0.107305 7.4378 0.0647606C7.36438 0.0222165 7.28279 0 7.19999 0C7.11718 0 7.0356 0.0222165 6.96218 0.0647606C6.88876 0.107305 6.82567 0.168919 6.77827 0.244364L3.53005 5.40094L0.878399 2.45351C0.806472 2.37338 0.714753 2.3188 0.61487 2.29666C0.514987 2.27453 0.411439 2.28585 0.317352 2.32918C0.223266 2.37252 0.142878 2.44592 0.0863799 2.54007C0.029882 2.63423 -0.000181403 2.74491 8.23525e-07 2.85808V10.2866C8.23525e-07 10.8929 0.216735 11.4742 0.602523 11.9029C0.988311 12.3315 1.51155 12.5724 2.05714 12.5724H12.3428C12.8884 12.5724 13.4117 12.3315 13.7975 11.9029C14.1832 11.4742 14.4 10.8929 14.4 10.2866V2.85808C14.4002 2.74491 14.3701 2.63423 14.3136 2.54007C14.2571 2.44592 14.1767 2.37252 14.0826 2.32918C13.9885 2.28585 13.885 2.27453 13.7851 2.29666C13.6852 2.3188 13.5935 2.37338 13.5216 2.45351L10.8699 5.40094L7.6217 0.244364Z"
      fill="currentColor"
    />
  </svg>
);

export default Crown;
